import { useEffect } from 'react';

const setMeta = (selector, attr, value, create) => {
  let el = document.head.querySelector(selector);
  if (!el && create) {
    el = create();
    document.head.appendChild(el);
  }
  if (el) el.setAttribute(attr, value);
};

// Updates <title>, meta description, canonical and OG/Twitter url+title per route.
export const usePageSeo = ({ title, description, canonical, robots }) => {
  useEffect(() => {
    if (!title) return;
    document.title = title;
    const robotsEl = document.head.querySelector('meta[name="robots"]');
    if (robots) {
      setMeta('meta[name="robots"]', 'content', robots, () => {
        const m = document.createElement('meta');
        m.setAttribute('name', 'robots');
        return m;
      });
    } else if (robotsEl) {
      robotsEl.remove();
    }
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="title"]', 'content', title);
    setMeta('link[rel="canonical"]', 'href', canonical, () => {
      const l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      return l;
    });
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:url"]', 'content', canonical);
  }, [title, description, canonical, robots]);
};

// Scrolls to a section once the page has painted (header is sticky, so offset it).
export const useScrollToSection = (sectionId) => {
  useEffect(() => {
    if (!sectionId) {
      window.scrollTo({ top: 0 });
      return;
    }
    const timer = setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (!el) return;
      const headerOffset = 84;
      const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 350);
    return () => clearTimeout(timer);
  }, [sectionId]);
};
